import $ from 'jquery';

export default class LoadMore {
    constructor() {
        if ($('.js-load-more').length) {
            let current_page = 1;

            $('body').on('click', '.js-load-more', function() {
                const $this = $(this);
                const $post_type = $this.data('post-type');
                const $load = $this.data('load');

                // Track current page
                current_page++;

                $.ajax({
                    type: 'POST',
                    url: portman.ajax_url,
                    dataType: 'json',
                    data: {
                        action: 'load_more',
                        paged: current_page,
                        post_type: $post_type || 'post',
                        load: $load || 4
                    },
                    success: function (res) {
                        // If no more pages, hide button
                        if(current_page >= res.max) {
                            $this.hide();
                        };

                        // Append new items
                        $('.js-news-items').append(res.html);
                    }
                });
            });
        };
    };
};
